// extracted by mini-css-extract-plugin
export var body = "_cs-0";
export var sectionHeader = "_cs-4";
export var shortcutColumns = "_cs-2";
export var shortcutList = "_cs-1";
export var shortcutSection = "_cs-3";